import ManualPriceWarning from './component';

export default ManualPriceWarning;
